import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SurveyForm, SurveyFormPayload } from './types';
import { getSurveyForms, createSurveyForm, setActiveSurveyForm } from './surveyFormsApi';

interface SurveyFormsState {
  items: SurveyForm[];
  loading: boolean;
  error: string | null;
}

const initialState: SurveyFormsState = {
  items: [],
  loading: false,
  error: null,
};

export const loadSurveyForms = createAsyncThunk<SurveyForm[], string>(
  'surveyForms/load',
  async (surveyId) => getSurveyForms(surveyId)
);

export const addSurveyForm = createAsyncThunk<SurveyForm, { surveyId: string; payload: SurveyFormPayload }>(
  'surveyForms/add',
  async ({ surveyId, payload }) => createSurveyForm(surveyId, payload)
);

export const activateSurveyFormVersion = createAsyncThunk<SurveyForm[], { surveyId: string; formId: string }>(
  'surveyForms/setActive',
  async ({ surveyId, formId }) => {
    await setActiveSurveyForm(surveyId, formId);
    return getSurveyForms(surveyId);
  }
);

const surveyFormsSlice = createSlice({
  name: 'surveyForms',
  initialState,
  reducers: {
    clearForms(state) {
      state.items = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loadSurveyForms.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loadSurveyForms.fulfilled, (state, action: PayloadAction<SurveyForm[]>) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(loadSurveyForms.rejected, (state) => {
        state.loading = false;
        state.error = 'No se pudieron cargar los formularios';
      })
      .addCase(addSurveyForm.fulfilled, (state, action) => {
        const rest = state.items.filter((f) => f.id !== action.payload.id);
        state.items = [action.payload, ...rest].sort((a, b) => b.version - a.version);
      })
      .addCase(activateSurveyFormVersion.pending, (state) => {
        state.error = null;
      })
      .addCase(activateSurveyFormVersion.fulfilled, (state, action) => {
        state.items = action.payload;
      })
      .addCase(activateSurveyFormVersion.rejected, (state) => {
        state.error = 'No se pudo cambiar la revisión vigente';
      });
  },
});

export const { clearForms } = surveyFormsSlice.actions;

export default surveyFormsSlice.reducer;














